






































import Vue from 'vue'
import NavBar from '@/components/NavBar.vue'
import SideBar from '@/components/SideBar.vue'
import Footer from '@/components/Footer.vue'
import { MetaInfo } from 'vue-meta/types/vue-meta'
import MetaContent from '@/constants/metaContent'

export default Vue.extend({
  components: {
    NavBar,
    SideBar,
    Footer
  },
  metaInfo (): MetaInfo {
    return {
      title: MetaContent.TITLE,
      titleTemplate: (titleChunk) => {
        return titleChunk || MetaContent.TITLE
      },
      meta: [
        {
          vmid: 'keywords',
          property: 'keywords',
          template: chunk => chunk || MetaContent.KEYWORDS,
          content: MetaContent.KEYWORDS
        },
        {
          vmid: 'description',
          property: 'description',
          template: chunk => chunk || MetaContent.DESCRIPTION,
          content: MetaContent.DESCRIPTION
        },
        {
          vmid: 'author',
          name: 'author',
          template: chunk => chunk || MetaContent.AUTHOR,
          content: MetaContent.AUTHOR
        },
        {
          vmid: 'og:title',
          property: 'og:title',
          template: chunk => chunk || MetaContent.OG_TITLE,
          content: MetaContent.OG_TITLE
        },
        {
          vmid: 'og:image',
          property: 'og:image',
          template: chunk => chunk || MetaContent.OG_IMAGE,
          content: MetaContent.OG_IMAGE
        },
        {
          vmid: 'og:description',
          property: 'og:description',
          template: chunk => chunk || MetaContent.OG_DESCRIPTION,
          content: MetaContent.OG_DESCRIPTION
        },
        {
          property: 'og:type',
          content: MetaContent.OG_TYPE
        },
        {
          vmid: 'og:url',
          property: 'og:url',
          content: window.location.href
        },
        {
          property: 'og:site_name',
          content: MetaContent.OG_SITENAME
        },
        {
          name: 'apple-itunes-app',
          content: 'app-id=584787808',
          'app-argument': 'from_web_index'
        },
        {
          name: 'google-play-app',
          content: 'app-id=tw.com.nuphoto.nuphoto'
        }
      ]
    }
  },
  computed: {
    isVisibleInCurrentPath (): boolean {
      const visiblePaths = ['Home', 'Product']
      return visiblePaths.includes(this.$route.name || '')
    },
    isShowFooter (): boolean {
      const invisibleFooterRoutes = ['Cart', 'Checkout', 'Login', 'Payment', 'SignUp', 'PersonalBook', 'PersonalBookCover', 'PersonalBook2', 'BookPreview']
      if (invisibleFooterRoutes.some(name => this.$route.name === name)) {
        return false
      }
      return !this.$store.getters.isWebViewMode && this.$store.getters.showFooter
    },
    isShowNavBar (): boolean {
      const disableRoutesList = ['Payment']
      if (disableRoutesList.some(routeName => this.$route.name === routeName)) { return false }
      if (/webview=1/.test(window.location.href) || this.$store.getters.isWebViewMode) { return false }
      return true
    }
  },
  methods: {
    scrollToTop () {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    handleScroll () {
      const scrollButttonElement = this.$refs[
        'nu-scroll-top-btn'
      ] as HTMLElement
      if (scrollButttonElement) {
        const navbar = document.getElementById('nu-navbar') as HTMLElement
        const notAtTop = window.scrollY > (navbar ? navbar.offsetHeight : 0)
        scrollButttonElement.style.transform = notAtTop
          ? ''
          : 'translateY(3rem)'
        scrollButttonElement.style.opacity = notAtTop ? '0.75' : '0'
      }
    },
    loadData () {
      const view = this.$refs.view as Vue
      // Resolve when router change vue component does not exist, we only want to refresh data when the route is the same vue component
      if (view) { view.$emit('loadData') }
    }
  }
})
